import { createGlobalStyle } from "styled-components"

export const CSSReset = createGlobalStyle`
  @page {
    size: portrait;
  }

  [data-testid="vertical-footer"], 
  [data-testid="vertical-header"],
  #debugger-root {
    @media print {
      display: none;
    }
  }
`
